import { MenuAction } from '@shared/interfaces/header/menu-action';
import { PencilLine, PlusSquare } from 'lucide-angular';

export const veeActionMenu: MenuAction[] = [
  {
    id: 'add',
    icon: PlusSquare,
    title: 'vee.action.add',
  },
  {
    id: 'edit',
    icon: PencilLine,
    title: 'vee.action.edit',
  },
];
